import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Checkbox } from 'mailup-web-components'

import { modalBulkAddToGroupToggleOptSetAsTestGroupCallback } from 'Pages/RecipientsList/recoil/callbacks/modalBulkAddToGroup'
import { modalBulkAddToGroupState } from 'Pages/RecipientsList/recoil/state/modals'

const InputSetAsTest: FC = () => {
  const intl = useIntl()

  const { optSetAsTestGroup } = useRecoilValue(modalBulkAddToGroupState)

  const toggleOptSetAsTestGroup = useRecoilCallback(
    modalBulkAddToGroupToggleOptSetAsTestGroupCallback,
    [],
  )

  return (
    <Checkbox
      checked={optSetAsTestGroup}
      data-mu-test="opt-set-as-test-group"
      label={intl.formatMessage({
        id: 'Load.RecipientsList.SetTargetAsTestGroup',
      })}
      onChange={toggleOptSetAsTestGroup}
    />
  )
}

export default InputSetAsTest
